// Client Portal — real FastAPI + MongoDB backend (Phase 2 · Module B).
// Sanitized, self-scoped bundle. For client_user the backend forces the
// client_id from the JWT (the param is ignored server-side).
import { api } from "@/lib/api";

export const fetchPortalSummary = (clientId) =>
  api.get("/portal/summary", { params: clientId ? { client_id: clientId } : {} }).then((r) => r.data);

export const fetchPortalLandings = (clientId) =>
  api.get("/portal/landings", { params: clientId ? { client_id: clientId } : {} }).then((r) => r.data);

export const fetchPortalDocuments = (clientId) =>
  api.get("/portal/documents", { params: clientId ? { client_id: clientId } : {} }).then((r) => r.data);

export const openPortalDocument = async (docId, clientId) => {
  const { data, headers } = await api.get(`/portal/documents/${docId}/download`, {
    params: clientId ? { client_id: clientId } : {},
    responseType: "blob",
  });
  const url = window.URL.createObjectURL(new Blob([data], { type: headers["content-type"] }));
  window.open(url, "_blank", "noopener");
  setTimeout(() => window.URL.revokeObjectURL(url), 60000);
};

export const downloadPortalDocument = async (docId, filename, clientId) => {
  const { data, headers } = await api.get(`/portal/documents/${docId}/download`, {
    params: clientId ? { client_id: clientId } : {},
    responseType: "blob",
  });
  const url = window.URL.createObjectURL(new Blob([data], { type: headers["content-type"] }));
  const a = document.createElement("a");
  a.href = url; a.download = filename || "documento";
  document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => window.URL.revokeObjectURL(url), 60000);
};

export const fetchPortalSocial = () => api.get("/social/portal/social-connections").then((r) => r.data);
export const connectPortalSocial = (platform) => api.post(`/social/portal/social-connections/${platform}/connect`).then((r) => r.data);

export const fetchPortalTickets = (clientId) =>
  api.get("/portal/support/tickets", { params: clientId ? { client_id: clientId } : {} }).then((r) => r.data);

export const createPortalTicket = (body, clientId) =>
  api.post("/portal/support/tickets", body, { params: clientId ? { client_id: clientId } : {} }).then((r) => r.data);

export const sendPortalAssistanceRequest = (body, clientId) =>
  api.post("/portal/support/request", body, { params: clientId ? { client_id: clientId } : {} }).then((r) => r.data);

export const updatePortalPhone = (phone) =>
  api.patch("/portal/profile/phone", { phone }).then((r) => r.data);

// Stripe Connect nel portale — connessione UNICA per cliente, sincronizzata con Anagrafica.
export const fetchPortalStripe = (clientId) =>
  api.get("/portal/stripe", { params: clientId ? { client_id: clientId } : {} }).then((r) => r.data);
export const startPortalStripeOnboard = (originUrl, clientId) =>
  api.post("/portal/stripe/onboard", { origin_url: originUrl, ...(clientId ? { client_id: clientId } : {}) }).then((r) => r.data);
export const fetchPortalStripeTransactions = (clientId) =>
  api.get("/portal/stripe/transactions", { params: clientId ? { client_id: clientId } : {} }).then((r) => r.data);

export const fetchPortalSupportForm = (clientId) =>
  api.get("/portal/support/form", { params: clientId ? { client_id: clientId } : {} }).then((r) => r.data?.form || null);
export const fetchPortalSupportForms = (clientId) =>
  api.get("/portal/support/forms", { params: clientId ? { client_id: clientId } : {} }).then((r) => r.data?.forms || []);
